import { render, staticRenderFns } from "./FormDateInput.vue?vue&type=template&id=3620a86c&scoped=true&"
import script from "./FormDateInput.vue?vue&type=script&lang=js&"
export * from "./FormDateInput.vue?vue&type=script&lang=js&"
import style0 from "./FormDateInput.vue?vue&type=style&index=0&id=3620a86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3620a86c",
  null
  
)

export default component.exports